import { buildQuery, queryParams } from "helpers/reqparams";
import { Filter, OrderBy } from "odata-query";
import { request } from "services/request";

const resource = "api/carsPlanning";

const getReport = (
    params: { length: number; start: number; orderBy?: OrderBy<{}>; filter: Filter<{}> },
    queryP: {},
) => {
    const qp = queryParams(queryP);

    const odataQuery = buildQuery({
        top: params.length,
        skip: params.start,
        filter: params.filter,
        ...(params.orderBy ? { orderBy: params.orderBy } : {}),
    }).substring(1);

    const query = [qp, odataQuery].join("&");
    return request(`${resource}/getReport${query}`, { method: "GET" });
};

const getTrailerTypes = (queryP: {}) => {
    const qp = queryParams(queryP);
    return request(`${resource}/getTrailerTypes${qp}`, { method: "GET" });
};

const getResponsibles = (queryP: {}) => {
    const qp = queryParams(queryP);
    return request(`${resource}/getResponsibles${qp}`, { method: "GET" });
};

export { getReport, getTrailerTypes, getResponsibles };
